/* import __COLOCATED_TEMPLATE__ from './reviewable-field.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./reviewable-field.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));